<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <div>
      <base-button type="primary" @click.prevent="onNew" icon>
        <span class="btn-inner--icon">
          <i class="ni e-add"></i>
        </span>New stage
      </base-button>
      <base-button type="info" @click.prevent="onRefresh" icon>
        <span class="btn-inner--icon">
          <i class="ni refresh-02"></i>
        </span>Refresh
      </base-button>
    </div>
    <el-table :data="tableData" row-key="id" header-row-class-name="thead-light">
      <el-table-column min-width="620px">
        <template v-slot="{row}">
          <div class="d-flex justify-content-center"></div>
          <stage-item
            :duration="row.duration"
            :level="row.levelname"
            :description="row.description"
            :title="row.title"
            :orderindex="row.orderindex"
          ></stage-item>
        </template>
      </el-table-column>
      <el-table-column min-width="120px" align="right" label="Actions">
        <div slot-scope="{$index, row}" class="d-flex">
          <base-button
            @click.native="onEdit($index, row)"
            class="edit"
            type="warning"
            size="sm"
            icon
          >
            <i class="text-white ni n-edit"></i>
          </base-button>
          <base-button
            @click.native="onDelete($index, row)"
            class="remove btn-link"
            type="danger"
            size="sm"
            icon
          >
            <i class="text-white ni e-remove"></i>
          </base-button>
        </div>
      </el-table-column>
    </el-table>

    <modal :show.sync="modalform" size="lg">
      <h6 slot="header" class="modal-title">Stage action</h6>
      <validation-observer ref="formvalid">
        <div class="row">
          <div class="col-lg-8">
            <base-input
              name="title"
              rules="required"
              v-model="stage.title"
              class="mb-3"
              label="Title"
              placeholder="Title"
            ></base-input>
          </div>
          <div class="col-lg-4">
            <base-input
              name="duration"
              v-model="stage.duration"
              type="number"
              label="Duration (weeks)"
              minValue="1"
              placeholder="Duration in weeks"
              max="100"
              min="1"
            ></base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <base-input label="Description" class="mr-1">
              <textarea class="form-control" rows="3" resize="none" v-model="stage.description"></textarea>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input label="Level" rules="required" name="level">
              <el-select
                class="select-primary pagination-select"
                v-model="stage.level"
                placeholder="Level"
              >
                <el-option
                  class="select-primary"
                  v-for="(item,index) in levels"
                  :key="index"
                  :label="item"
                  :value="index + 1"
                ></el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              v-model="stage.orderindex"
              type="number"
              placeholder="Order"
              label="Order index"
              max="100"
              min="0"
            ></base-input>
          </div>
        </div>
      </validation-observer>
      <div class="text-center">
        <base-button type="primary" @click.native="onSaveStage">Save changes</base-button>
      </div>
    </modal>
  </div>
</template>

<script>
import swal from "sweetalert2";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import { Table, TableColumn, Select, Option } from "element-ui";
import { Modal, BaseAlert } from "@/components";
import StageItem from "./StageItem";
import { StageType } from "../../../services/types";
import {
  GetStages,
  GetStage,
  DeleteStage,
  CreateStage,
  UpdateStage,
} from "../../../services/courses";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "stages",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    StageItem,
    Modal,
    HtmlEditor,
    Loading,
  },
  props: {
    courseId: String,
  },
  computed: {
    mode() {
      return this.stage.id ? "Edit" : "Create";
    },
  },
  data() {
    return {
      tableData: [],
      isLoading: false,
      modalform: false,
      stage: {},
      levels: ["Easy", "Normal", "Hard"],
    };
  },
  methods: {
    htmldescription(value) {
      return ShowLink(HtmlNewLine(value));
    },
    loadStages() {
      this.tableData = [];
      if (!this.courseId) return;
      this.isLoading = true;
      GetStages(this.courseId).then((response) => {
        this.isLoading = false;
        if (response.data.result !== undefined) {
          this.tableData = response.data.result;
        } else {
          if (response.data) this.notifyVue("danger", response.data);
        }
      });
    },
    onNew() {
      this.stage = new StageType();
      this.stage.courseId = this.courseId;
      this.modalform = true;
    },
    onEdit(index, row) {
      this.stage = Object.assign({}, row);
      this.modalform = true;
    },
    onSaveStage() {
      this.$refs.formvalid.validate().then((valid) => {
        if (valid) {
          this.isLoading = true;
          if (this.mode === "Create") {
            CreateStage(this.stage).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.modalform = false;
                this.loadStages();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          } else {
            UpdateStage(this.stage).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.modalform = false;
                this.loadStages();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        }
      });
    },
    onRefresh() {
      this.loadStages();
    },
    onDelete(index, row) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;
            DeleteStage(row.id).then((response) => {
              this.isLoading = false;
              if (response.data.result) {
                this.loadStages();
              } else {
                this.notifyVue("danger", response.data);
              }
            });
          }
        });
    },
  },
  mounted() {
    this.loadStages();
  },
  watch: {
    courseId: function () {
      this.loadStages();
    },
  },
};
</script>
